import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/store/user'
import { getReportsAuthorized } from '@/services/reports'

// 路由组件懒加载
const Login = () => import('@/views/Login.vue')
const TicketList = () => import('@/views/TicketList.vue')
const TicketDetail = () => import('@/views/TicketDetail.vue')
const MyTicketDetail = () => import('@/views/MyTicketDetail.vue')
const NotificationList = () => import('@/views/NotificationList.vue')
const MyTickets = () => import('@/views/MyTickets.vue')
const CreateTicket = () => import('@/views/CreateTicket.vue')
const UserProfile = () => import('@/views/UserProfile.vue')
const WeChatConfig = () => import('@/views/WeChatConfig.vue')
const Reports = () => import('@/views/Reports.vue')
const ThemeDemo = () => import('@/views/ThemeDemo.vue')

const routes = [
  {
    path: '/',
    redirect: '/tickets'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { 
      title: '登录',
      requiresAuth: false 
    }
  },
  {
    path: '/tickets',
    name: 'TicketList',
    component: TicketList,
    meta: { 
      title: '工单列表',
      requiresAuth: true 
    }
  },
  {
    path: '/tickets/:id',
    redirect: to => {
      return `/ticket-detail/${to.params.id}`
    },
    meta: { 
      requiresAuth: true 
    }
  },
  {
    path: '/ticket-detail/:id',
    name: 'TicketDetail',
    component: TicketDetail,
    meta: { 
      title: '工单详情',
      requiresAuth: true 
    }
  },
  {
    path: '/my-ticket-detail/:id',
    name: 'MyTicketDetail',
    component: MyTicketDetail,
    meta: { 
      title: '我的工单详情',
      requiresAuth: true 
    }
  },
  {
    path: '/notifications',
    name: 'NotificationList',
    component: NotificationList,
    meta: { 
      title: '通知列表',
      requiresAuth: true 
    }
  },
  {
    path: '/my-tickets',
    name: 'MyTickets',
    component: MyTickets,
    meta: { 
      title: '我的工单',
      requiresAuth: true 
    }
  },
  {
    path: '/create-ticket',
    name: 'CreateTicket',
    component: CreateTicket,
    meta: { 
      title: '创建工单',
      requiresAuth: true 
    }
  },
  {
    path: '/profile',
    name: 'UserProfile',
    component: UserProfile,
    meta: { 
      title: '个人资料',
      requiresAuth: true 
    }
  },
  {
    path: '/wechat-config',
    name: 'WeChatConfig',
    component: WeChatConfig,
    meta: { 
      title: '企业微信配置',
      requiresAuth: true 
    }
  },
  {
    path: '/reports',
    name: 'Reports',
    component: Reports,
    meta: {
      title: '统计报表',
      requiresAuth: true
    }
  },
  {
    path: '/iot-devices/control',
    name: 'IotControl',
    component: () => import('@/views/IotControl.vue'),
    meta: {
      title: '设备控制',
      requiresAuth: true
    }
  },
  {
    path: '/theme-demo',
    name: 'ThemeDemo',
    component: ThemeDemo,
    meta: {
      title: '大尺寸主题演示',
      requiresAuth: false
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 全局路由守卫
router.beforeEach(async (to, from, next) => {
  const userStore = useUserStore()
  
  // 设置页面标题
  document.title = to.meta.title ? `${to.meta.title} - 超级店长系统` : '超级店长系统'
  
  // 检查是否需要认证
  if (to.meta.requiresAuth) {
    if (userStore.isAuthenticated) {
      // 按门店策略拦截“我的工单”
      const store = userStore.currentStore
      if (to.name === 'MyTickets' && store && store.allow_ticket_creation === false) {
        // 禁止进入“我的工单”，重定向到工单列表
        next('/tickets')
        return
      }
      // 报表权限拦截
      if (to.name === 'Reports') {
        const cached = localStorage.getItem('reportsAuthorized')
        if (cached === 'true') {
          next()
          return
        }
        try {
          const res = await getReportsAuthorized()
          const ok = !!(res && res.authorized)
          localStorage.setItem('reportsAuthorized', ok ? 'true' : 'false')
          if (!ok) {
            next('/tickets')
            return
          }
        } catch (e) {
          localStorage.setItem('reportsAuthorized', 'false')
          next('/tickets')
          return
        }
      }
      next()
    } else {
      // 保存当前要访问的页面路径，登录后跳转回来
      const redirectPath = to.fullPath
      next(`/login?redirect=${encodeURIComponent(redirectPath)}`)
    }
  } else {
    // 如果已登录用户访问登录页，重定向到工单列表
    if (to.path === '/login' && userStore.isAuthenticated) {
      next('/tickets')
    } else {
      next()
    }
  }
})

export default router